import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/hooks/api/models';

/**
 * 2170. 発注ダッシュボード（チーム別合計金額）
 * [GET] /workspaces/:identifier/purchase_dashboard/amount_by_team
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  payment_context_ids?: number[];
};

export type PurchaseDashboardAmountByTeam = {
  names: string[];
  amounts: number[];
};

const purchaseDashboardAmountByTeam = (props: Props): Promise<PurchaseDashboardAmountByTeam> => {
  return axios.get(`/api/workspaces/${props.identifier}/purchase_dashboard/amount_by_team`, { params: props });
};

export const usePurchaseDashboardAmountByTeam = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'purchase_dashboard', 'amount_by_team', { ...props }],
    queryFn: () => purchaseDashboardAmountByTeam(props),
    staleTime: 1000 * 60 * 30,
  });
};
